import { translateInComponent } from 'infras/i18n';
import translations from 'presentations/views/components/pages/PricingEducationPage/i18n.json';
import MainDocument from 'presentations/views/components/MainDocument';
import PricingEducationPage from 'presentations/views/components/pages/PricingEducationPage';
import { pricingEducationPath, webPath } from 'presentations/routes/path';
import { useRouter } from 'next/router';

export default function Page() {
  const t = translateInComponent(translations);
  const router = useRouter();

  return (
    <MainDocument
      title={t('title')}
      linkCanonical={webPath(pricingEducationPath(), router.locale)}
    >
      <PricingEducationPage />
    </MainDocument>
  );
}
